exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-component='change-pass'] .reset-pass {\n  width: 100%;\n}\n[data-component='change-pass'] .reset-pass .form-reset-pass {\n  width: 220px;\n  display: inline-block;\n}\n[data-component='change-pass'] [data-component='signature'] [data-component='virtual-num-pad'] {\n  margin: -37px 110px 0 0;\n}\n[data-component='change-pass'] [data-component='virtual-num-pad'] {\n  margin: 0 110px 0 0;\n  opacity: 0;\n  visibility: hidden;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/cards/change-pass/change-pass.component.styl
// module id = ../../../../../src/app/master/cards/change-pass/change-pass.component.styl
// module chunks = main